export default "__VITE_ASSET__CDFL9ukD__"